import { EyeOff } from 'lucide-react'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { cn } from 'src/shared/components/ui/utils'

export const OnlyVisibleToYouBadge = ({
  className,
  label,
}: {
  className?: string
  /** Override default copy (e.g. preview / example states). */
  label?: string
}) => {
  const { t } = useLocalization()

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md bg-stone-100 px-1.5 py-0.5 text-[10px] font-medium text-stone-600',
        className
      )}
    >
      <EyeOff className="h-3 w-3 shrink-0 opacity-70" aria-hidden />
      {label ?? t('Only visible to you', 'Bara synligt för dig')}
    </span>
  )
}
